const messages = {
  subtitle: "Uw contactpersoon bij Bridgestone",
  title: "Contactpersonen en servicenummers",
  description:
    "Wij staan voor u klaar! Hieronder vindt u de gegevens van uw Bridgestone contactpersonen en de vertegenwoordigers van uw regio.",
  teams: {
    direct: "Direct",
    indirect: "Indirect",
    tyre: "Team bandenhandel",
    car: "Team autodealers",
    lkw: "Team vrachtwagens",
    em_otr: "Team EM/OTR",
    farm_tractor: "Team landbouwtractoren",
    bandag: "Team Bandag",
    subtitle: "Uw contactpersoon bij Bridgestone",
  },
  contact: {
    index: {
      title: "Contact & Service",
      description:
        "Wij staan voor u klaar! Hieronder vindt u de gegevens van uw Bridgestone contactpersonen en de vertegenwoordigers van uw regio.",
    },
    categories: {
      service: {
        description: "Contact met Bridgestone",
      },
      touch: {
        title: "Contact Touch Incentive",
        short_desc: "",
        description:
          "Heeft u een probleem met uw <span class='text-danger'>bestelling in de Bridgestone PLUS Gift Shop? (geen bandenbestellingen)</span> Hier vindt u de contactgegevens van de leverancier.",
      },
      bridgestone: {
        title: "BRIDGESTONE PLUS ONDERSTEUNING",
        short_desc:
          "Heeft u een vraag over het gebruik van het Bridgestone Plus-platform?\n" +
          "Ons team helpt u graag verder.",
        description:
          "Voor alle vragen over het gebruik van het Bridgestone Plus-platform of de verschillende toepassingen ervan, kunt u contact met ons opnemen via het volgende e-mailadres: plus-nl&commat;bridgestone.eu ",
      },
      dekouple: {
        title: "SHOP ONDERSTEUNING",
        short_desc:
          "Voor vragen over uw productbestelling (met uitzondering van Bridgestone-artikelen of bandbestellingen), kunt u contact opnemen via het toegewezen emailadres.",
        description:
          "<b>Een vraag over uw bestelling in de Bridgestone-shop (met uitzondering van Bridgestone-artikelen of bandbestellingen)?</b> Of het nu gaat om beschikbare producten, een geplaatste bestelling, leveringstermijnen of het volgen van de levering: u kunt rechtstreeks contact opnemen met onze leverancier, <b>Dekuple Coup de Poing</b>, via e-mail op het adres bridgestoneplus.nl&#64;coupdepoing.com.",
      },
      contact: {
        short_desc:
          "Heeft u <span class='text-danger'>algemene vragen of opmerkingen</span> over Bridgestone PLUS, onze services of onze producten? Klik dan hieronder voor onze contactgevens",
      },
    },
    strategicPartners: {
      cardTitle: "Contact met de distributeurs",
      short_desc:
        "Heeft <span class='text-danger'>u vragen over uw bandenbestellingen</span> bij de aangesloten distributeurs? Klik dan hieronder voor hun contactgegevens.",
    },
  },
};

export default {
  messages,
};
